import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {isEmpty} from 'lodash';

import {SUMMARY_TAB, TRAVEL_TAB, ECONOMIC_TAB, HEALTH_TAB} from '../../extras';

import TravelNavigation from './components/TravelNavigation';
import EmptyTab from './components/EmptyTab';
import SummaryTab from './components/SummaryTab';
import TravelTab from './components/TravelTab';

import {containerStyles} from 'styles/shared';

const TravelDetailsContainer = styled.div`
  width: 54.4rem;
  height: 69.8rem;
  margin-bottom: 5rem;
  margin-right: 5rem;
  padding: 4.3rem 5rem;
  ${containerStyles};
`;

const TABS = [SUMMARY_TAB, TRAVEL_TAB, ECONOMIC_TAB, HEALTH_TAB];

TravelDetails.propTypes = {
  travelDetails: PropTypes.object.isRequired
};

function TravelDetails({travelDetails}) {
  const [tabSelected, setTabSelected] = useState(SUMMARY_TAB);

  function selectTab(tab) {
    setTabSelected(tab);
  }

  function renderSelectedTab() {
    if (isEmpty(travelDetails)) return <EmptyTab />;

    let data = [];

    switch (tabSelected) {
      case SUMMARY_TAB:
        return <SummaryTab data={travelDetails[SUMMARY_TAB]} />;

      case TRAVEL_TAB:
        data = travelDetails[TRAVEL_TAB];
        break;

      case ECONOMIC_TAB:
        data = travelDetails[ECONOMIC_TAB];
        break;

      case HEALTH_TAB:
        data = travelDetails[HEALTH_TAB];
        break;

      default:
        return null;
    }

    return <TravelTab data={data} />;
  }

  function render() {
    return (
      <TravelDetailsContainer>
        <TravelNavigation tabs={TABS} tabSelected={tabSelected} onChange={selectTab} />

        {renderSelectedTab()}
      </TravelDetailsContainer>
    );
  }

  return render();
}

export default TravelDetails;
